import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const moveFromPendingToCutting = createAsyncThunk('moveFromPendingToCutting', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/move-from-shipment-pending-to-cutting`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file);
    bodyFormData.append('vendor_id', data?.vendor?.vendor_id );
    bodyFormData.append('vendor_name', data?.vendor?.vendor_name );
    bodyFormData.append('sheet_format', data?.sheet_format);
    bodyFormData.append('clear_the_rest', data?.clear_the_rest);
    bodyFormData.append('create_new_production_order', data?.create_new_production_order);
    bodyFormData.append('move_remaining_sku_for_give_style', data?.move_remaining_sku_for_give_style);
    bodyFormData.append('create_po', data?.create_po);
    // if (data?.verticals) {
    //     bodyFormData.append('verticals', JSON.stringify(data?.verticals));
    // }

    
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" },'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `vendor_clearance_result.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response





        // const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        // const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', `invoice_${data.invoice_number}.xlsx`);
        // document.body.appendChild(link);
        // link.click();
        // return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
    }
});